// extracted by mini-css-extract-plugin
module.exports = {"Container":"Confirm_Container__2GN6a","Content":"Confirm_Content__1B5bj","Question":"Confirm_Question__2lq88","Buttons":"Confirm_Buttons__3Te3w"};